import { Component, OnInit } from '@angular/core'
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent {}
